export default "__VITE_ASSET__8tiC5Z$m__"